<section class="endorsements-strip" aria-labelledby="endorsements-heading" itemscope
  itemtype="https://schema.org/Organization">
  <!-- Schema invisible metadata for AEO Answer Engines -->
  <meta itemprop="name" content="Estancos Distilling Company" />
  <meta itemprop="url" content="https://estancosdistillingcompany.com" />
  <meta itemprop="description"
    content="Destilería ecuatoriana de alta gama reconocida por la Asociación Iberoamericana de Ronmeliers y certificada por The Whisky Ambassador." />

  <!-- Fondo decorativo sutil con destellos dorados -->
  <div class="strip-glow-accent strip-glow-left" aria-hidden="true"></div>
  <div class="strip-glow-accent strip-glow-right" aria-hidden="true"></div>

  <div class="container">

    <!-- Encabezado de la Franja -->
    <div class="strip-header">
      <div class="strip-badge">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
        </svg>
        <span>Respaldados por la Industria</span>
      </div>
      <h2 id="endorsements-heading" class="strip-title">
        Avales y Reconocimientos Oficiales
      </h2>
      <p class="strip-subtitle">
        Nuestros destilados andinos y procesos de maduración a 2500 msnm cuentan con el respaldo de las organizaciones
        de mayor prestigio internacional en ron y whisky.
      </p>
    </div>

    <!-- Grid de Reconocimientos -->
    <div class="endorsements-grid" role="list" aria-label="Organizaciones que avalan a Estancos Distilling Company">

      @for (item of recognitions; track item.id) {
      <article class="endorsement-card" role="listitem" itemprop="hasCredential" itemscope
        itemtype="https://schema.org/EducationalOccupationalCredential">
        <!-- Metadatos de Credencial Schema.org -->
        <meta itemprop="credentialCategory" [content]="item.badge" />
        <meta itemprop="name" [content]="item.title" />

        <!-- Cabecera de la Tarjeta con Logo y Distintivo -->
        <div class="card-main-row">
          <div class="logo-wrapper" [class.light-bg]="item.id === 'whisky-ambassador'">
            <img [src]="item.logoUrl"
              [alt]="'Logo oficial de ' + item.title + ' que avala a Estancos Distilling Company'"
              class="endorsement-logo" loading="lazy" decoding="async" width="160" height="80"
              (error)="onImageError($event, item.id === 'asociacion-ronmeliers' ? 'ron' : 'whisky')" />
          </div>

          <div class="card-title-group">
            <div class="card-badge-row">
              <span class="badge-tag">{{ item.badge }}</span>
              <span class="scope-tag">{{ item.scope }}</span>
            </div>
            <h3 class="card-org-name" itemprop="recognizedBy" itemscope itemtype="https://schema.org/Organization">
              <span itemprop="name">{{ item.organization }}</span>
            </h3>
          </div>
        </div>

        <!-- Declaración descriptiva concisa (Target para fragmentos destacados de Google/LLMs) -->
        <p class="card-description" itemprop="description">
          {{ item.description }}
        </p>

        <!-- Bloque AEO: Tripletas Semánticas Explícitas (Sujeto - Predicado - Objeto) -->
        <div class="semantic-triplets-container" aria-label="Relaciones semánticas estructuradas">
          <div class="triplets-tag-header">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="16" x2="12" y2="12" />
              <line x1="12" y1="8" x2="12.01" y2="8" />
            </svg>
            <span>Acreditaciones</span>
          </div>

          <div class="triplets-list">
            @for (triplet of item.triplets; track triplet.subject + '-' + triplet.predicate) {
            <div class="triplet-capsule" itemscope itemtype="https://schema.org/PropertyValue">
              <span class="triplet-node triplet-subject" itemprop="name" title="Sujeto">
                <span class="node-label">Sujeto:</span>
                <strong>{{ triplet.subject }}</strong>
              </span>
              <span class="triplet-predicate" title="Predicado">
                <span class="predicate-arrow">➔</span>
                <em>{{ triplet.predicate }}</em>
              </span>
              <span class="triplet-node triplet-object" itemprop="value" title="Objeto">
                <span class="node-label">Objeto:</span>
                <strong>{{ triplet.object }}</strong>
              </span>
            </div>
            }
          </div>
        </div>

      </article>
      }

    </div>

    <!-- Franja resumen de confianza rápida (Trust ticker) -->
    <footer class="strip-footer">
      <div class="footer-highlight">
        <span class="highlight-bullet">✦</span>
        <span>
          <strong>Garantía de Origen:</strong> Cada botella de <em>Ron Legarda</em> y <em>Whisky Real Audiencia</em> es
          destilada y añejada bajo rigurosos protocolos certificados.
        </span>
      </div>
    </footer>

  </div>
</section>